import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
} from "react-admin";
import OrgSelector from "../../components/OrgSelector";

const PanelEdit = (props) => {

  return (
    <Edit {...props} title="Edit Panel">
      <SimpleForm {...props}>
        <OrgSelector required />
        <TextInput source="uid" validate={[required()]} />
        <TextInput source="access_code" validate={[required()]} />
        <TextInput source="installer_code" validate={[required()]} />
        <TextInput label="Destination IP" source="ip" validate={[required()]} />
        {/* <TextInput source="panel_ip" validate={[required()]}  /> */}
        <TextInput source="notes" />
      </SimpleForm>
    </Edit>
  );
};

export default PanelEdit;
